export const LOADING_NOTIFICATION_TYPE = "LOADING_NOTIFICATION_TYPE";
export const SAVE_LOADING_NOTIFICATION_TYPE = "SAVE_LOADING_NOTIFICATION_TYPE";
export const GET_NOTIFICATION_TYPE = "GET_NOTIFICATION_TYPE";
export const FORM_FAIL = "FORM_FAIL";
export const NOTIFICATION_TYPE_FAIL = "NOTIFICATION_TYPE_FAIL";
export const LOADING_NOTIFICATION_TYPE_BY_ID = "LOADING_NOTIFICATION_TYPE_BY_ID";
export const GET_NOTIFICATION_TYPE_BY_ID = "GET_NOTIFICATION_TYPE_BY_ID";